var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
//TODO refactor bulk action and row action to single funtion to decrease repeatabillity
import React, { useMemo, useState, useEffect } from "react";
import Table, { Pagination } from "./base-table";
import { createTable, useTableInstance, getCoreRowModel, getFilteredRowModel, getSortedRowModel, getPaginationRowModel, } from "./react-table.js";
import { Icon } from "../icon";
import Box from "../templates/box";
import Flex from "../templates/flex";
import SearchInput from "../search";
import { Checkbox } from "../checkbox";
import Action from "./action";
import ComparisonFilter from "./comparisonFilter";
import { comparison } from "./filterFns";
export var supportedBulkActions = {
    delete: {
        icon: "trashcan",
        confirmation: true,
        tooltipText: "Delete",
        confirmationTitle: "Delete Row",
        confirmationMessage: "You are about to delete a row, are you sure you want to continue?",
        confirmLabel: "Yes",
        declineLabel: "No",
        actionButtonDirection: "reverse",
    },
    download: { icon: "download", confirmation: false, tooltipText: "Download" },
    toggleAlarm: { icon: "alarm_off", confirmation: false, tooltipText: "Turn of Alarms" },
};
export var supportedRowActions = {
    delete: {
        icon: "trashcan",
        confirmation: true,
        tooltipText: "Delete",
        confirmationTitle: "Delete Row",
        confirmationMessage: "You are about to delete a row, are you sure?",
        confirmLabel: "Yes",
        declineLabel: "No",
        actionButtonDirection: "reverse",
    },
    info: { icon: "information", confirmation: false, tooltipText: "Information" },
    toggleAlarm: { icon: "alarm_off", confirmation: false, tooltipText: "Turn of Alarms" },
};
var table = createTable().setOptions({ filterFns: { comparison: comparison } });
var NetdataTable = function (_a) {
    var dataColumns = _a.dataColumns, data = _a.data, onRowSelected = _a.onRowSelected, onGlobalSearchChange = _a.onGlobalSearchChange, enableSelection = _a.enableSelection, globalFilterFn = _a.globalFilterFn, tableRef = _a.tableRef, enableSorting = _a.enableSorting, _b = _a.rowActions, rowActions = _b === void 0 ? {} : _b, _c = _a.bulkActions, bulkActions = _c === void 0 ? {} : _c, onClickRow = _a.onClickRow, enablePagination = _a.enablePagination, _d = _a.paginationOptions, paginationOptions = _d === void 0 ? {
        pageIndex: 0,
        pageSize: 0,
    } : _d, _e = _a.testPrefix, testPrefix = _e === void 0 ? "" : _e;
    var _f = useState([]), originalSelectedRows = _f[0], setOriginalSelectedRow = _f[1];
    var _g = useState([]), sorting = _g[0], setSorting = _g[1];
    var _h = useState({}), rowSelection = _h[0], setRowSelection = _h[1];
    var _j = useState(""), globalFilter = _j[0], setGlobalFilter = _j[1];
    var _k = useState({
        pageIndex: paginationOptions.pageIndex,
        pageSize: paginationOptions.pageSize,
    }), pagination = _k[0], setPagination = _k[1];
    var availableRowActions = Object.keys(rowActions).reduce(function (acc, currentActionKey) {
        var isActionSupported = supportedRowActions[currentActionKey];
        if (!isActionSupported)
            return [];
        var _a = supportedRowActions[currentActionKey], icon = _a.icon, confirmation = _a.confirmation, tooltipText = _a.tooltipText, confirmationTitle = _a.confirmationTitle, confirmationMessage = _a.confirmationMessage, confirmLabel = _a.confirmLabel, declineLabel = _a.declineLabel, handleDecline = _a.handleDecline, actionButtonDirection = _a.actionButtonDirection;
        var currentAction = rowActions[currentActionKey];
        acc.push(__assign({ confirmation: confirmation, tooltipText: tooltipText, icon: icon, id: currentActionKey, confirmationTitle: confirmationTitle, confirmationMessage: confirmationMessage, confirmLabel: confirmLabel, declineLabel: declineLabel, handleDecline: handleDecline, actionButtonDirection: actionButtonDirection }, currentAction));
        return acc;
    }, []);
    var availableBulkActions = Object.keys(bulkActions).reduce(function (acc, currentActionKey) {
        var isBulkActionSupported = supportedBulkActions[currentActionKey];
        if (!isBulkActionSupported)
            return [];
        var _a = supportedBulkActions[currentActionKey], icon = _a.icon, confirmation = _a.confirmation, tooltipText = _a.tooltipText, confirmationTitle = _a.confirmationTitle, confirmationMessage = _a.confirmationMessage, confirmLabel = _a.confirmLabel, declineLabel = _a.declineLabel, handleDecline = _a.handleDecline, actionButtonDirection = _a.actionButtonDirection;
        var currentAction = bulkActions[currentActionKey];
        acc.push(__assign({ confirmation: confirmation, tooltipText: tooltipText, icon: icon, id: currentActionKey, confirmationTitle: confirmationTitle, confirmationMessage: confirmationMessage, confirmLabel: confirmLabel, declineLabel: declineLabel, handleDecline: handleDecline, actionButtonDirection: actionButtonDirection }, currentAction));
        return acc;
    }, []);
    var makeDataColumns = useMemo(function () {
        if (!dataColumns || dataColumns.length < 1)
            return [];
        return dataColumns.map(function (_a, index) {
            var header = _a.header, id = _a.id, cell = _a.cell, _b = _a.enableFilter, enableFilter = _b === void 0 ? false : _b, isPlaceholder = _a.isPlaceholder, filterFn = _a.filterFn, _c = _a.enableGlobalFilter, enableGlobalFilter = _c === void 0 ? true : _c, meta = _a.meta;
            if (!id)
                throw new Error("Please provide id  at ".concat(index));
            return table.createDataColumn(id, __assign(__assign(__assign(__assign({}, (cell && { cell: typeof cell === "function" ? function (props) { return cell(props); } : cell })), (header && { header: typeof header === "function" ? function () { return header(); } : header })), (filterFn ? { filterFn: filterFn } : {})), { footer: function (props) { return props.column.id; }, enableColumnFilter: enableFilter, enableGlobalFilter: enableGlobalFilter, isPlaceholder: isPlaceholder, meta: meta }));
        });
    }, [dataColumns]);
    var makeSelectionColumn = enableSelection ? [renderRowSelection({ testPrefix: testPrefix })] : [];
    var makeActionsColumn = availableRowActions.length > 0
        ? [renderActions({ actions: availableRowActions, testPrefix: testPrefix })]
        : [];
    var handleGlobalSearch = function (value) {
        onGlobalSearchChange === null || onGlobalSearchChange === void 0 ? void 0 : onGlobalSearchChange(value);
        setGlobalFilter(String(value));
    };
    var instance = useTableInstance(table, __assign(__assign({ columns: __spreadArray(__spreadArray(__spreadArray([], makeSelectionColumn, true), makeDataColumns, true), makeActionsColumn, true), data: data, state: __assign({ rowSelection: rowSelection, globalFilter: globalFilter, sorting: sorting }, (enablePagination ? { pagination: pagination } : {})) }, (globalFilterFn ? { globalFilterFn: globalFilterFn } : {})), { getCoreRowModel: getCoreRowModel(), getFilteredRowModel: getFilteredRowModel(), onRowSelectionChange: setRowSelection, onGlobalFilterChange: handleGlobalSearch, onSortingChange: setSorting, getSortedRowModel: getSortedRowModel(), getPaginationRowModel: getPaginationRowModel(), onPaginationChange: setPagination }));
    useEffect(function () {
        var rows = instance.getSelectedRowModel().rows;
        if (rows) {
            var selectedRows = rows.reduce(function (acc, _a) {
                var original = _a.original;
                if ((original === null || original === void 0 ? void 0 : original.disabled) === true)
                    return acc;
                acc.push(original);
                return acc;
            }, []);
            setOriginalSelectedRow(selectedRows);
            onRowSelected === null || onRowSelected === void 0 ? void 0 : onRowSelected(selectedRows);
        }
    }, [rowSelection, instance]);
    var headers = instance.getFlatHeaders();
    return (React.createElement(Table, { selectedRows: originalSelectedRows, bulkActions: availableBulkActions, Pagination: enablePagination && renderPagination({ instance: instance }), handleSearch: onGlobalSearchChange ? handleGlobalSearch : null, ref: tableRef, "data-testid": "netdata-table".concat(testPrefix), testPrefix: testPrefix },
        React.createElement(Table.Head, { "data-testid": "netdata-table-head".concat(testPrefix) },
            React.createElement(Table.HeadRow, { "data-testid": "netdata-table-headRow".concat(testPrefix) }, renderHeadCell({ headers: headers, enableSorting: enableSorting, testPrefix: testPrefix }))),
        React.createElement(Table.Body, { "data-testid": "netdata-table-body".concat(testPrefix) }, instance.getRowModel().rows.map(function (row) { return (React.createElement(Table.Row, { "data-testid": "netdata-table-row".concat(testPrefix), onClick: function () { return onClickRow === null || onClickRow === void 0 ? void 0 : onClickRow(row.original, row); }, key: row.id }, row.getVisibleCells().map(function (cell) { return (React.createElement(Table.Cell, { "data-testid": "netdata-table-cell".concat(testPrefix), key: cell.id }, cell.renderCell())); }))); }))));
};
var renderHeadCell = function (_a) {
    var headers = _a.headers, enableSorting = _a.enableSorting, testPrefix = _a.testPrefix;
    var HeadCell = headers.map(function (_a) {
        var id = _a.id, colSpan = _a.colSpan, renderHeader = _a.renderHeader, isPlaceholder = _a.isPlaceholder, column = _a.column;
        var getCanSort = column.getCanSort, columnDef = column.columnDef;
        var meta = columnDef.meta;
        var availableFilters = { comparison: ComparisonFilter, default: SearchFilter };
        var selectedFilter = meta && meta.filter ? meta.filter : "default";
        var Filter = availableFilters[selectedFilter];
        if (getCanSort() && enableSorting) {
            return (React.createElement(Table.SortingHeadCell, { "data-testid": "netdata-table-head-cell".concat(testPrefix), sortDirection: column.getIsSorted(), onSortClicked: column.getToggleSortingHandler(), colSpan: colSpan, key: id, filter: column.getCanFilter() && React.createElement(Filter, { column: column, testPrefix: testPrefix }) }, isPlaceholder ? null : renderHeader()));
        }
        return (React.createElement(Table.HeadCell, { "data-testid": "netdata-table-head-cell".concat(testPrefix), colSpan: colSpan, key: id },
            isPlaceholder ? null : renderHeader(),
            column.getCanFilter() ? (React.createElement("div", null,
                React.createElement(Filter, { column: column, testPrefix: testPrefix }))) : null));
    });
    return HeadCell;
};
var renderPagination = function (_a) {
    var instance = _a.instance;
    var nextPage = instance.nextPage, previousPage = instance.previousPage, getCanPreviousPage = instance.getCanPreviousPage, getCanNextPage = instance.getCanNextPage, getPageCount = instance.getPageCount;
    var pageSize = instance.getState().pagination.pageSize;
    var pageIndex = instance.getState().pagination.pageIndex;
    return (React.createElement(Pagination, { pageCount: getPageCount(), hasNext: getCanNextPage(), hasPrevious: getCanPreviousPage(), onNextPage: nextPage, onPreviousPage: previousPage, pageSize: pageSize, pageIndex: pageIndex + 1 }));
};
var renderActions = function (_a) {
    var actions = _a.actions, testPrefix = _a.testPrefix;
    return table.createDataColumn("actions", {
        header: function () {
            return "Actions";
        },
        cell: function (_a) {
            var _b, _c;
            var row = _a.row;
            var isDisabled = (_c = (_b = row.original) === null || _b === void 0 ? void 0 : _b.disabled) !== null && _c !== void 0 ? _c : false;
            return (React.createElement(Flex, { "data-testid": "action-cell", height: "100%", gap: 2 }, actions.map(function (_a) {
                var id = _a.id, icon = _a.icon, handleAction = _a.handleAction, tooltipText = _a.tooltipText, confirmation = _a.confirmation, confirmationTitle = _a.confirmationTitle, confirmationMessage = _a.confirmationMessage, confirmLabel = _a.confirmLabel, declineLabel = _a.declineLabel, handleDecline = _a.handleDecline, actionButtonDirection = _a.actionButtonDirection;
                return (React.createElement(Action, { disabled: isDisabled, actionButtonDirection: actionButtonDirection, handleDecline: handleDecline, declineLabel: declineLabel, confirmLabel: confirmLabel, confirmationMessage: confirmationMessage, confirmationTitle: confirmationTitle, confirmation: confirmation, key: id, id: id, icon: icon, handleAction: function () { return handleAction(row.original); }, tooltipText: tooltipText, testPrefix: testPrefix }));
            })));
        },
        enableColumnFilter: false,
        enableSorting: false,
    });
};
var renderRowSelection = function (_a) {
    var testPrefix = _a.testPrefix;
    return table.createDataColumn("checkbox", {
        header: function (_a) {
            var instance = _a.instance;
            return (React.createElement(ColumnCheckbox, { "data-testid": "netdata-table-header-checkbox".concat(testPrefix), checked: instance.getIsAllPageRowsSelected(), indeterminate: instance.getIsSomePageRowsSelected(), onChange: instance.getToggleAllPageRowsSelectedHandler() }));
        },
        cell: function (_a) {
            var _b, _c;
            var row = _a.row;
            var isDisabled = (_c = (_b = row.original) === null || _b === void 0 ? void 0 : _b.disabled) !== null && _c !== void 0 ? _c : false;
            return (React.createElement(ColumnCheckbox, { "data-testid": "netdata-table-cell-checkbox".concat(testPrefix), checked: row.getIsSelected(), indeterminate: row.getIsSomeSelected(), onChange: row.getToggleSelectedHandler(), disabled: isDisabled }));
        },
        enableColumnFilter: false,
        enableSorting: false,
    });
};
var SearchFilter = function (_a) {
    var column = _a.column, testPrefix = _a.testPrefix;
    var columnFilterValue = column.getFilterValue();
    var _b = column.id, id = _b === void 0 ? "" : _b;
    return (React.createElement(Box, { "data-testid": "netdata-table-filter-".concat(id).concat(testPrefix), as: SearchInput, width: { max: 50 }, value: columnFilterValue !== null && columnFilterValue !== void 0 ? columnFilterValue : "", placeholder: "...Search", iconRight: React.createElement(Icon, { name: "magnify" }), onChange: function (e) { return column.setFilterValue(e.target.value); } }));
};
var ColumnCheckbox = function (_a) {
    var checked = _a.checked, indeterminate = _a.indeterminate, onChange = _a.onChange, disabled = _a.disabled, rest = __rest(_a, ["checked", "indeterminate", "onChange", "disabled"]);
    return (React.createElement(Checkbox, __assign({ disabled: disabled, checked: checked, indeterminate: indeterminate, onChange: onChange }, rest)));
};
export default NetdataTable;
